import { render, staticRenderFns } from "./exclusivePanningList.vue?vue&type=template&id=4b2fd352&scoped=true"
import script from "./exclusivePanningList.vue?vue&type=script&lang=js"
export * from "./exclusivePanningList.vue?vue&type=script&lang=js"
import style0 from "./exclusivePanningList.vue?vue&type=style&index=0&id=4b2fd352&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2fd352",
  null
  
)

export default component.exports